<template>
  <div class="commodity-content">
    <div class="commodity-foreach" v-for="(item, index) of auctionList" :key="index" @click="linkToDetail(item)">
      <div class="title-style">
        <img src="@/assets/imgs/match/店铺@2x.png" alt="">
        <span>{{item.sellerName}}</span>
        <img src="@/assets/imgs/toProduct/编组 2备份@2x.png" alt="">
      </div>

      <div style="display: flex">
        <div class="commodity-foreach-left">
          <img :src="item.image" alt="">
        </div>
        <div class="commodity-foreach-right">
          <div class="right-title">
            {{ item.auTitle }} {{ item.auCode }} {{ item.description }}
          </div>
          <div class="right-price">
            <img src="@/assets/imgs/match/路径@2x.png" alt="">
            <span><span>￥<span>{{ $utils.emptyFormat(item.fsPrice) }}</span></span> /{{ item.measureUnit }}</span>
          </div>
          <div class="right-num">
            <span>已闪购：{{ $utils.emptyFormat(item.soldWeight) }}{{ item.measureUnit }}</span>
            <!-- <div>
              <van-progress :percentage="50" stroke-width="8" color="#F73F29" :show-pivot="false" />
            </div> -->
          </div>
          <div class="right-times">
            {{ item.validBeginTime | dateFilter("time") }} 至{{ item.finalEndTime | dateFilter("time") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fastShoppingImg } from "../fast-shopping-utils";
export default {
  name: "FlashSaleListItem",
  props: ["auctionList"],
  data() {
    return {
      fastShoppingImg: fastShoppingImg,
    };
  },
  computed: {
    curTime() {
      return new Date().getTime();
    },
  },
  methods: {
    auctionLink() {
      this.$toast("请到电脑端参与竞拍");
    },
    // 详情
    linkToDetail(item) {
      this.$router.push(`/flashSaleDetail?fsId=${item.fsId}`);
    },
  },
};
</script>

<style lang='stylus' scoped>
.commodity-content {
  padding: 32px;

  .commodity-foreach {
    box-sizing: border-box;
    font-size: 24px;
    background: #fff;
    border-radius: 16px 16px 16px 16px;
    padding: 38px 24px;
    margin-bottom: 32px;

    .title-style {
      display: flex;
      align-items: center;
      margin-bottom: 32px;

      span {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #333333;
        margin: 0 12px;
      }

      img:nth-child(1) {
        width: 32px;
        height: 32px;
      }

      img:nth-child(3) {
        width: 24px;
        height: 24px;
      }
    }

    .commodity-foreach-left {
      margin-right: 20px;

      img {
        width: 176px;
        height: 176px;
      }
    }

    .commodity-foreach-right {
      flex: 1;
      overflow: hidden;

      .right-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #333333;
        line-height: 33px;
        margin-bottom: 32px;
      }

      .right-price {
        position: relative;
        margin-bottom: 16px;

        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 33px;
          height: 56px;
        }

        > span {
          display: inline-block;
          // width: 197px;
          padding-left: 16px;
          padding-right: 14px;
          height: 56px;
          line-height: 56px;
          text-align: center;
          border-radius: 16px;
          background: rgba(242, 39, 24, 0.06);
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #999999;
          margin-left: 2px;

          > span {
            color: #FF5500;

            > span {
              font-size: 38px;
            }
          }
        }
      }

      .right-num {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        margin-bottom: 20px;

        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 20px;
          color: #666666;
          margin-bottom: 8px;
        }

        > div {
          box-sizing: border-box;
          width: 100%;
          padding-left: 56px;

          /deep/ .van-progress {
            width: 100%;
            height: 12px !important;
            background: #FEF2F1;
            border-radius: 8px 8px 8px 8px;
          }
        }
      }

      .right-times {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #666666;
      }
    }
  }
}
</style>
